/* V81: fixed header clearance is measured once per mobile layout width.
   iOS Safari changes visual viewport height on normal scrolling; ignore those events. */
(function () {
  'use strict';
  function start() {
    if (!document.body || !document.body.classList.contains('mh-has-custom-header')) return;
    var root = document.documentElement;
    var topbar = document.getElementById('mainTopbar');
    var nav = document.getElementById('mainNav');
    if (!topbar || !nav) return;
    var applied = -1, lastWidth = window.innerWidth, raf = 0;
    var mobile = function () { return window.innerWidth <= 900; };
    function measure() {
      raf = 0;
      if (mobile()) {
        // offsetHeight, unlike rect.bottom, cannot move with Safari's visual viewport.
        var barHeight = topbar.offsetHeight;
        var navHeight = nav.offsetHeight;
        var height = Math.round(barHeight + navHeight);
      } else {
        var barRect = topbar.getBoundingClientRect();
        var navRect = nav.getBoundingClientRect();
        var height = Math.ceil(Math.max(barRect.bottom, navRect.bottom));
      }
      if (height < 60 || height > 190 || height === applied) return;
      applied = height;
      root.style.setProperty('--mh-fixed-header-height', height + 'px');
    }
    function queueMeasure() { if (!raf) raf = requestAnimationFrame(measure); }
    function onRealResize() {
      var width = window.innerWidth;
      if (Math.abs(width - lastWidth) < 2) return;
      lastWidth = width;
      queueMeasure();
    }
    // Do not observe mobile header heights. Safari can cause ResizeObserver loops
    // from address-bar movement, font/viewport recalculation and late reflow.
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        if (!mobile()) queueMeasure();
      });
      observer.observe(topbar); observer.observe(nav);
    }
    window.addEventListener('resize', onRealResize, { passive:true });
    window.addEventListener('orientationchange', function () { lastWidth = -1; queueMeasure(); }, { passive:true });
    document.addEventListener('mh:promotion-change', queueMeasure);
    queueMeasure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
